import React, { useEffect } from 'react'
import { withRouter } from 'react-router-dom'

import AppFreestyleSongService from '../../../../../../services/AppFreestyleSongService'
import PageLoader from '../../../components/molecules/PageLoader'
import { Page } from '../../../components/molecules/Page'
import AlertConfirmation from '../../../components/molecules/AlertConfirmation'
import { CURATED_CLASS_TYPE } from '../../../../../../entities/CuratedClassEntity'
import { FREESTYLE_CLASS_TYPE } from '../../../../../../entities/FreestyleClassEntity'

const FreestyleSongDelete = ({ activeUser, match, history }) => {
  const { songID, classID } = match.params
  const [selectedSong, setSelectedSong] = React.useState(null)
  const classType = FREESTYLE_CLASS_TYPE
  const pageContent = {
    pageTitle: 'Delete Freestyle Song:',
    introText: '',
  }

  const freestyleSongService = new AppFreestyleSongService()

  useEffect(() => {
    ;(async songID => {
      const data = await freestyleSongService.fetchFreestyleSong(songID)
      // console.log('FreestyleSongDelete: data', data)
      setSelectedSong(data)
    })(songID)
    // console.log('FreestyleSongDelete: data',selectedSong)
  }, [songID, classID, freestyleSongService])

  const deleteHandler = async songID => {
    await freestyleSongService.deleteFreestyleSong(songID)
    history.push(`/${classType}/class/${classID}/songs`)
  }

  const cancelHandler = () => {
    history.push(`/${classType}/class/${classID}/songs`)
  }

  if (selectedSong !== null) {
    if (selectedSong.length === 0) {
      history.push(`/${classType}/class/${classID}/songs`) // Not Found
      return null
    }

    let canDelete = false
    if (
      selectedSong.freestyleClass.type === CURATED_CLASS_TYPE &&
      activeUser.isAdminUser()
    ) {
      canDelete = true
    }
    if (selectedSong.freestyleClass.type === FREESTYLE_CLASS_TYPE) {
      if (activeUser.authUsername === selectedSong.owner) {
        canDelete = true
      }
    }

    if (canDelete) {
      return (
        <Page.WithTitle pageContent={pageContent}>
          <RenderDeleteConfirmButton
            {...{
              song: selectedSong,
              classType,
              classID,
              onConfirm: deleteHandler,
              onCancel: cancelHandler,
            }}
          />
        </Page.WithTitle>
      )
    }
    return (
      <Page.WithTitle pageContent={pageContent}>
        You do not have permission to delete this song.
      </Page.WithTitle>
    )
  } else {
    return <PageLoader />
  }
}

export default withRouter(FreestyleSongDelete)

const RenderDeleteConfirmButton = ({
  song,
  classType,
  classID,
  onConfirm,
  onCancel,
}) => {
  const confirmDeleteProps = {
    trigger: false,
    title: 'Are you sure?',
    content: `Deleting "${song.song}" by "${song.artist}" is permanent.`,
    cancelLabel: 'Cancel',
    onCancel: onCancel,
    confirmLabel: 'Delete',
    onConfirm: onConfirm.bind(this, song.id, classType, classID),
  }
  return <AlertConfirmation {...confirmDeleteProps} />
}
